import React from 'react';
import { TrustBar } from './components/TrustBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { ProblemSolution } from './components/ProblemSolution';
import { WhatYouLearn } from './components/WhatYouLearn';
import { AboutSpeaker } from './components/AboutSpeaker';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FooterCTA } from './components/FooterCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { TrackingScripts } from './components/TrackingScripts';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-mint/20 selection:text-brand-mint" data-id="element-0">
      <TrackingScripts data-id="element-1" />
      <TrustBar data-id="element-2" />
      <StickyMobileCTA data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <SocialProof data-id="element-6" />
        <ProblemSolution data-id="element-7" />
        <WhatYouLearn data-id="element-8" />
        <AboutSpeaker data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FAQ data-id="element-11" />
        <FooterCTA data-id="element-12" />
      </main>

      <footer className="bg-slate-900 text-slate-400 py-8 text-center text-sm" data-id="element-13">
        <div className="max-w-6xl mx-auto px-4" data-id="element-14">
          <p data-id="element-15">
            © {new Date().getFullYear()} Stressless Dogs. Alle rechten
            voorbehouden.
          </p>
        </div>
      </footer>
    </div>;
}